export default "/images/d69a0c1c1461ff8c2d8b814a56a4a333.avif";